import { takeEvery } from 'redux-saga/effects';

import * as actions from 'store/modules/messagesPage';

import { deleteMessage } from './utils';

export default function* listenDeleteMessage() {
  yield takeEvery(actions.deleteMessage.toString(), deleteMessage);
}
